module.exports = __webpack_public_path__ + "img/9.47e7c4f3.jpg";